<template>
	<div id="app">
		<router-view />
		<span v-show="isIdle"></span>
		<!-- <el-button type="primary" v-on:click="getToken">获取授权</el-button> -->
		<div id="modelDiv"></div>
		<!-- 这个是用来展示弹框内容的 -->
		<div id="model">
			<i
				class="el-icon-loading"
				style="font-size: 20px; vertical-align: sub"
			></i>
			<span>服务器断开连接，正在重连...</span>
		</div>

		<!-- 首次登录必须修改密码 不可关闭 -->
		<el-dialog
			title="首次登录必须修改密码"
			:visible.sync="showFirstLoginPwdModal"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			width="450px"
			center
		>
			<el-form
				:model="firstLoginPwdForm"
				status-icon
				:rules="firstLoginPwdRules"
				ref="firstLoginPwdForm"
				label-width="100px"
			>
				<el-form-item label="原始密码" prop="originalPassword">
					<el-input
						type="password"
						v-model="firstLoginPwdForm.originalPassword"
						placeholder="请输入原始密码"
						show-password
					></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input
						type="password"
						v-model="firstLoginPwdForm.newPassword"
						placeholder="请输入新密码"
						show-password
					></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPassword">
					<el-input
						type="password"
						v-model="firstLoginPwdForm.confirmPassword"
						placeholder="请再次输入新密码"
						show-password
					></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFirstLoginPwd" :loading="firstLoginPwdLoading">确认修改</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
	name: 'App',
	data() {
		const validateConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入新密码'))
			} else if (value !== this.firstLoginPwdForm.newPassword) {
				callback(new Error('两次输入的密码不一致'))
			} else {
				callback()
			}
		}
		return {
			repeatEntry: false,
			showFirstLoginPwdModal: false,
			firstLoginPwdLoading: false,
			firstLoginPwdForm: {
				newPassword: '',
				confirmPassword: '',
			},
			firstLoginPwdRules: {
				originalPassword: [
					{ required: true, message: '请输入原始密码', trigger: 'blur' },
				],
				newPassword: [
					{ required: true, message: '请输入新密码', trigger: 'blur' },
					{ min: 6, max: 16, message: '密码长度在6到16个字符之间', trigger: 'blur' },
				],
				confirmPassword: [
					{ required: true, validator: validateConfirmPassword, trigger: 'blur' },
				],
			},
		}
	},
	created() {
		console.log(this.$store)
		this.checkFirstLogin()
	},
	watch: {
		$route() {
			this.checkFirstLogin()
		},
	},
	computed: {
		isIdle() {
			let conversationDataCount = parseInt(
				localStorage.getItem(conversationDataCount)
			)
			let loginModel = JSON.parse(localStorage.getItem(this.LoginInfo))
			if (
				(conversationDataCount == 0 || isNaN(conversationDataCount)) &&
				this.isAppIdle &&
				!this.repeatEntry &&
				loginModel
			) {
				this.repeatEntry = true
				let $this = this
				this.axios
					.get('Login', {
						params: { token: loginModel.token, state: null },
					})
					.then(function ({ data }) {})
				this.$alert(
					'您已经在一段时间内没有活动了。为了确保您的账户安全，请您重新登录',
					'提示',
					{
						confirmButtonText: '确定',
						type: 'error',
						callback: (action) => {
							$this.repeatEntry = false
							localStorage.clear()
							$this.$router.push({ path: '/login' })
						},
					}
				)
			}
			return this.isAppIdle
		},
	},
	methods: {
		checkFirstLogin() {
			if (this._globle.firstLoginKey) {
				this.showFirstLoginPwdModal = true
			}
		},
		submitFirstLoginPwd() {
			const vm = this
			this.$refs.firstLoginPwdForm.validate((valid) => {
				if (valid) {
					vm.firstLoginPwdLoading = true
					const params = {
						newsPassword: vm.encryptECB(vm.firstLoginPwdForm.newPassword),
						checkPass: vm.encryptECB(vm.firstLoginPwdForm.confirmPassword),
						originalPassword: vm.encryptECB(vm.firstLoginPwdForm.originalPassword),
					}
					vm.axios
						.post('User/upd_pass', params)
						.then(function ({ data }) {
							vm.firstLoginPwdLoading = false
							if (data.result) {
								vm.$message.success('密码修改成功')
								vm._globle.firstLoginKey = false
								vm.showFirstLoginPwdModal = false
								vm.$refs.firstLoginPwdForm.resetFields()
							} else {
								vm.$message.error(data.message || '密码修改失败')
							}
						})
						.catch(function () {
							vm.firstLoginPwdLoading = false
							vm.$message.error('请求失败，请稍后重试')
						})
				} else {
					return false
				}
			})
		},
		encryptECB(plaintText) {
			var plaintText = plaintText
			var options = {
				mode: CryptoJS.mode.ECB,
				padding: CryptoJS.pad.Pkcs7,
			}
			var key = CryptoJS.enc.Utf8.parse('e0YDC3vNOWhtY7Qy')
			var encryptedData = CryptoJS.AES.encrypt(plaintText, key, options)
			var encryptedBase64Str = encryptedData.toString()
			return encryptedBase64Str
		},
	},}
</script>

<style>
#modelDiv {
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background: silver;
	opacity: 0.8;
	z-index: 99;
	display: none;
}

#model {
	width: 300px;
	height: 37px;
	background: white;
	border-radius: 10px;
	padding: 15px;
	position: absolute;
	top: 200px;
	left: 42%;
	z-index: 99;
	display: none;
	line-height: 37px;
	color: red;
}

* {
	padding: 0;
	margin: 0;
}
.clear {
	clear: both;
}
ul {
	list-style: none;
}
input {
	outline: none;
}
a {
	cursor: pointer;
	text-decoration: none;
}
a:visited {
	color: #000;
}
body {
	color: #000;
	/* font-family:Source Han Sans CN;*/
	width: 100%;
	height: 100%;
	line-height: 1;
	margin: 0 auto;
	font-size: 14px;
	background-color: #fff;
	font: 12px/1.14 'Monospaced Number', 'Chinese Quote', '-apple-system',
		'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'PingFang SC',
		'Microsoft YaHei', 'Helvetica Neue', 'Hiragino Sans GB', 'Arial',
		'sans-serif';
}
#app {
	height: 100%;
	width: 100%;
	display: flex;
	flex-flow: row;
}
.g-flex {
	height: 100%;
	width: 100%;
	position: absolute;
	overflow-x: hidden;
	min-width: 1280px;
	min-height: 620px;
}
.g-container {
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
	background-color: #fff;
}
.cursor {
	cursor: pointer;
}
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue